import React, { useState, useMemo, useEffect } from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuPopover,
  MenuTrigger,
  MenuItemRadio,
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';
import {
  ArrowSort20Regular,
  ArrowSortUp20Regular,
  ArrowSortDown20Regular,
} from '@fluentui/react-icons';
import {
  CSMLSortIcon,
  CSMLSortBy,
} from '../../model';

const useStyles = makeStyles({
  menuPopover: {
    minWidth: '180px',
  },
  item: {
    '& .fui-MenuItem__content': {
      display: 'flex',
    },
  },
});

export const SortByFilter = (props) => {
  const {
    className,
    options,
    sortBy,
    onChange,
  } = props;

  const classes = useStyles();
  const name = 'sortBy';
  const [checkedValues, setCheckedValues] = useState({
    [name]: [sortBy || CSMLSortBy.MostRecent],
  });
  const [isOpen, setIsOpen] = useState(false);

  const onCheckedValueChange = (e, data) => {
    const {
      checkedItems,
    } = data;
    setCheckedValues(s => ({
      ...s,
      [name]: checkedItems,
    }));
    onChange(e, {
      key: checkedItems[0],
    });
  };

  const onOpenChange = (e, data) => {
    setIsOpen(data.open);
  };

  const selectedOptionMemo = useMemo(() => {
    const selectedOption = options.find(option => option.key === checkedValues[name][0]);
    return selectedOption ?
      <>
        {selectedOption.text}
        {selectedOption.icon && selectedOption.icon === CSMLSortIcon.SortUp && <ArrowSortUp20Regular />}
        {selectedOption.icon && selectedOption.icon === CSMLSortIcon.SortDown && <ArrowSortDown20Regular />}
      </> : '';
  }, [checkedValues, options]);

  // As, this could be modified by the parent component, we need to update the checkedValues
  useEffect(() => {
    if (sortBy === checkedValues[name][0]) {
      return;
    }
    if (sortBy == null) {
      return;
    }
    setCheckedValues({
      [name]: [sortBy],
    });
  }, [checkedValues, sortBy]);

  return (
    <div className={mergeClasses(className, 'sort-by-filter')}>
      <Menu open={isOpen} checkedValues={checkedValues} onCheckedValueChange={onCheckedValueChange} hasCheckmarks onOpenChange={onOpenChange}>
        <MenuTrigger disableButtonEnhancement>
          <MenuButton icon={<ArrowSort20Regular />}>
            {selectedOptionMemo}
          </MenuButton>
        </MenuTrigger>

        <MenuPopover className={mergeClasses('sort-filter-list', classes.menuPopover)}>
          <MenuList>
            {
              options.map((option, index) => (
                <MenuItemRadio key={option.key} name={name} value={option.key} className={option.icon ? mergeClasses(classes.item, `option${index}`) : `option${index}`}>
                  {option.text}
                  {option.icon && option.icon === CSMLSortIcon.SortUp && <ArrowSortUp20Regular />}
                  {option.icon && option.icon === CSMLSortIcon.SortDown && <ArrowSortDown20Regular />}
                </MenuItemRadio>
                ))
            }
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};

